import { api } from '@/lib/api';
import type { CisVerificationInput, CisVerificationResult } from '@pgs/shared';

// Verification drives a browser at HMRC (login + a step-up SMS OTP + multiple screens), so it
// can take a few minutes — override the client's default 30s timeout, with headroom over the
// API's own ~180s bot timeout.
export const verifyCis = async (input: CisVerificationInput): Promise<CisVerificationResult> =>
  (await api.post<CisVerificationResult>('/cis/verify', input, { timeout: 190_000 })).data;
